<template lang="html">
  <b-form id="products-results-page" @submit="onSubmit">
    <section class="products-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 box-breadcrumb-s1">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-display">
            <a class="btn-display" v-if="showAs == 'blocks'" @click="showAs = 'lists'">
              <i class="far fa-bars"></i>
            </a>
            <a class="btn-display" v-if="showAs == 'lists'" @click="showAs = 'blocks'">
              <i class="fas fa-th-large"></i>
            </a>
          </div>

          <div class="col-lg-12 col-results">
            <div class="row justify-content-center" v-if="showAs == 'lists'">
              <div class="col-12 col-xl-10 box-product-sample-s2" v-for="(p, plInx) in products" :key="'plInx-'+plInx">
                <div class="box-link">
                  <router-link
                    class="box-link"
                    :to="'/producto/'+p.id"
                    @click.native="saveScrollPosition"
                    style="text-decoration: none;">
                    <div class="col col-image">
                      <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+p.imageUrl+')' }">
                        <img class="d-none d-lg-block" src="public/images/shared/empty.png">
                        <img class="d-lg-none" src="public/images/shared/product.png">
                      </div>
                    </div>

                    <div class="col col-info">
                      <div class="box-bubbles">
                        <span class="bubble bg-2" v-if="p.recently_sold == 1">Sold</span>
                        <span class="bubble bg-3" v-if="p.new_arrival == 1">New arrivals</span>
                        <span class="bubble bg-4" v-if="p.sale_pending == 1">Sale pending</span>
                        <span class="bubble bg-5" v-if="p.in_stock == 1">In stock</span>
                        <span class="bubble bg-6" v-if="p.sale == 1">Sale</span>
                      </div>

                      <h6 class="brand">{{ p.brand }}</h6>
                      <h6 class="name">{{ p.name }}</h6>

                      <div class="d-none d-lg-block descr">
                        <p><strong>Reference: </strong> {{p.reference_number}}</p>
                      </div>
                      <div class="descr">
                        <p v-html="p.description"></p>
                      </div>

                      <h6 class="price" v-if="p.recently_sold != 1"><span>$</span> {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format(p.price) }} <span>USD</span></h6>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="row" v-if="showAs == 'blocks'">
              <div class="col-sm-6 col-lg-4 col-xl-3 box-product-sample-s1" v-for="(p, pInx) in products" :key="'pInx-'+pInx">
                <router-link
                  class="box-link"
                  :to="'/producto/'+p.id"
                  @click.native="saveScrollPosition">
                  <div class="box-image">
                    <img class="placed-backg" src="public/images/shared/product.png" v-bind:style="{ backgroundImage: 'url('+p.imageUrl+')' }">

                    <div class="box-bubbles">
                      <span class="bubble bg-2" v-if="p.recently_sold == 1">Sold</span>
                      <span class="bubble bg-3" v-if="p.new_arrival == 1">New arrivals</span>
                      <span class="bubble bg-4" v-if="p.sale_pending == 1">Sale pending</span>
                      <span class="bubble bg-5" v-if="p.in_stock == 1">In stock</span>
                      <span class="bubble bg-6" v-if="p.sale == 1">Sale</span>
                    </div>
                  </div>

                  <div class="box-descr">
                    <h6 class="brand">{{ p.brand }}</h6>
                    <h6 class="name">{{ p.name }}</h6>

                    <h6 class="price" v-if="p.recently_sold != 1">
                      <span v-if="p.price > 0">
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format(p.price) }} USD
                      </span>
                      <span v-else>
                        <router-link style="color: #75777a;font-family: Libre Bodoni, serif; font-size: 1.5rem;font-weight: 600;letter-spacing: 2px; margin-top: 10px;" to="/contacto">Contact us</router-link>
                      </span>
                    </h6>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      showFilters: false,
      showAs: 'blocks',

      formSearch: {
        keywords: null,
        order: 1,
        category: [],
        shape: [],
        price: null,
        discount: null,
      },

      products: [],

      pagination: {
        currentpage: 1,
        total: 1,
        total_products: 16,
        number: 10
      },
      id: null,
      keywords: null,
      scrolldata:0,
    };
  },
  watch: {
    '$route.params.id_cat': function () {
      this.id = this.$route.params.id_cat;
      this.getRow();
    },
    '$route.query.keywords': function () {
      this.keywords = this.$route.query.keywords;
      this.getRow();
    },
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    onSubmit(event) {
      event.preventDefault();
    },
    getRow() {
      this.$root.isLoading = true;
      axios.post(tools.url("/api/products/" + this.id), { keywords: this.keywords })
        .then((response) => {
          this.products = response.data;
          var self = this;
          setTimeout(() => {
            self.$root.isLoading = false;
          }, 900);

        })
        .catch((error) => {
          console.error(error);
          this.$root.isLoading = false;
        });
    },
    saveScrollPosition() {
      const scrollPosition = this.scrolldata;
      localStorage.setItem('scrollPosition', scrollPosition);
      console.log('Scroll position saved:', scrollPosition);
      this.$root.scrollCheck = true;
    },
    restoreScrollPosition() {
      const savedPosition = localStorage.getItem('scrollPosition');
      var self = this;
      if (self.$root.scrollCheck == true) {
        console.log('ok');
              setTimeout(function() {
                document.documentElement.scrollTop = savedPosition;
                self.$root.scrollCheck = false;
              }, 1800);


      }
    }
  },
  mounted() {
    this.keywords = this.$route.query.keywords;
    this.id = this.$route.params.id_cat;
    this.getRow();

    var self = this;
    window.onscroll = function() {
        if (self.$root.scrollCheck == false) {
            self.scrolldata = document.documentElement.scrollTop;
        }
    };

    this.restoreScrollPosition();
  }
}
</script>
